// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__36MZQ","wrapper-nopadding":"wrapper-nopadding__E5b92","loading":"loading__2MPCM","error":"error__z0sCU","table-loading":"table-loading__3aFj2","empty-val":"empty-val__EZZHf","panelheader-tools":"panelheader-tools__2fcNK","propsPanels":"propsPanels__2GXXO","new":"new__1-oYr","marginLm":"marginLm__vrvOC","marginRm":"marginRm__1bXTm","fullWidth":"fullWidth__2l671","fullHeight":"fullHeight__3khvs","noData":"noData__3gxO0","dataTable":"dataTable__YOfKb","pager":"pager__2kb5i"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceData/styles.scss
// module id = 2236
// module chunks = 1